<form
  (submit)="onSubmit()"
  [formGroup]="form"
  class="form-horizontal transfer-form"
>
  <ng-container formGroupName="main">
    <div class="card m-3">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h3 class="card-title">Allgemeine Daten</h3>
        <button class="btn btn-primary" [disabled]="!form.valid" type="submit">Speichern</button>
      </div>
      <div class="card-body">
        <app-form-group control="active" label="">
          <div class="form-check">
            <input
              class="form-check-input"
              id="active"
              formControlName="active"
              type="checkbox"
            >
            <label class="form-check-label" for="active">
              Aktiv
            </label>
          </div>
        </app-form-group>

        <div class="row mb-3">
          <div class="control-label col-sm-3">
            <label class="col-form-label">Default-Route</label>
          </div>
          <div class="col-sm-9">
            <span class="form-control-plaintext">
              {{ form.get("main.defaultRoute").value === true ? "Ja" : "Nein" }}
            </span>
          </div>
        </div>

        <app-form-group
          [group]="main"
          control="prefix"
          label="Präfix"
        >
          <input
            id="prefix"
            type="text"
            placeholder="Präfix"
            formControlName="prefix"
            class="form-control"
          />
        </app-form-group>
        <app-form-group
          [group]="main"
          control="identifier"
          label="Kennung"
        >
          <input
            id="identifier"
            type="text"
            placeholder="Kennung"
            formControlName="identifier"
            class="form-control"
          />
        </app-form-group>

        <app-form-group
          [group]="main"
          control="client"
          label="Client"
        >
          <p-select
            dataKey="id"
            [filter]="true"
            filterBy="name"
            formControlName="client"
            [options]="clients"
            optionLabel="name"
            placeholder="Client auswählen"
            styleClass="w-100"
          ></p-select>
        </app-form-group>

        <div class="row mb-3">
          <div class="col-sm-9 offset-sm-3">
            <app-certificate-selection-list
              *ngIf="form.get('main.client').value?.allowedCerts"
              [data]="form.get('main.client').value?.allowedCerts"
              [readonly]="true"
              title="Zugewiesene Zertifikate"
            >
            </app-certificate-selection-list>
          </div>
        </div>

        <app-form-group
          [group]="main"
          formGroupName="target"
          control="to"
          label="Endpunkt-URL"
        >
          <div class="d-flex gap-2">
            <input
              id="to"
              type="text"
              placeholder="Endpunkt-URL"
              formControlName="to"
              class="form-control"
            />

            <button
              type="button"
              class="btn btn-outline-secondary"
              (click)="loadDefaultRoute()"
              title="Default-Route"
            >
              <i class="fa fa-magic"></i>
            </button>
            <button
              type="button"
              (click)="openEndPunktListeModal()"
              class="btn btn-outline-secondary"
              title="Endpunkt-List"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
        </app-form-group>

        <app-form-group
          [group]="main"
          formGroupName="target"
          control="xta1Port"
          label="Xta1Port"
        >
          <input
            id="xta1Port"
            type="text"
            placeholder="xta1Port"
            formControlName="xta1Port"
            class="form-control"
          />
        </app-form-group>

        <app-form-group
          [group]="main"
          formGroupName="target"
          control="xta2SendPort"
          label="Xta2SendPort"
        >
          <input
            id="xta2SendPort"
            type="text"
            placeholder="xta2SendPort"
            formControlName="xta2SendPort"
            class="form-control"
          />
        </app-form-group>

        <app-form-group
          [group]="main"
          formGroupName="target"
          control="xta2MsgboxPort"
          label="Xta2MsgboxPort"
        >
          <input
            id="xta2MsgboxPort"
            type="text"
            placeholder="xta2MsgboxPort"
            formControlName="xta2MsgboxPort"
            class="form-control"
          />
        </app-form-group>

        <app-form-group
          [group]="main"
          formGroupName="target"
          control="xta2ManagePort"
          label="Xta2ManagePort"
        >
          <input
            id="xta2ManagePort"
            type="text"
            placeholder="xta2ManagePort"
            formControlName="xta2ManagePort"
            class="form-control"
          />
        </app-form-group>
      </div>
    </div>
    <div class="m-3">
      <app-private-key-view
        title="Privater Schlüssel für 'Mutual SSL Certification'"
        groupName="main"
        groupNameNew="key"
        [data]="data?.key"
        [storageData]="getStorageData('key')"
        (clickOnNew)="setClickOnNew()"
      >
      </app-private-key-view>
    </div>
  </ng-container>
</form>
